module.exports = __webpack_public_path__ + "img/road.d2fc858a.jpg";